import { RootState } from '../../../app/reducer';
import { DataState } from '../../../constants';
import { LiveFeedPostModel } from '../../../models';

export const selectLiveFeed = ({ liveFeedReducer }: RootState): LiveFeedPostModel[] =>
  liveFeedReducer.liveFeed.data;

export const selectLiveFeedState = ({ liveFeedReducer }: RootState): DataState =>
  liveFeedReducer.liveFeed.state;
